import React from 'react';
import { Collapse } from '@kunukn/react-collapse'; // eslint-disable-line no-restricted-imports

export const ANIMATION_DURATION = 280;

export const AnimatedCollapse = props => (
  <Collapse transition={`height ${ANIMATION_DURATION}ms cubic-bezier(0.4, 0, 0.2, 1)`} {...props} />
);
